import React from 'react';
import { AboutZev } from '../components/AboutZev';
import { FinalCTA } from '../components/FinalCTA';
import { LivingFeed } from '../components/LivingFeed';
import { Location } from '../components/Location';
import { PageIntro } from '../components/PageIntro';
import { TrustDiscovery } from '../components/TrustDiscovery';
export function AboutPage() {
  return <>
      <PageIntro eyebrow="About" title="Meet Zev" description="A place to slow down, reconnect and leave feeling better than when you arrived." data-id="element-693" data-mp="4w9sy9oq5jm" />
      <AboutZev variant="body" data-id="element-694" data-mp="3mcm74l08i4hr" />
      <TrustDiscovery data-id="element-695" data-mp="3ic29zhfnv0vm" />
      <LivingFeed data-id="element-696" data-mp="3ibk6q0ukzme7" />
      <Location data-id="element-697" data-mp="3id50ho92n1b0" />
      <FinalCTA data-id="element-698" data-mp="3iclrwy5b9p9n" />
    </>;
}